// extracted by mini-css-extract-plugin
export default {"footer__logo":"Logo_footer__logo__0Yk8y","header__logo":"Logo_header__logo__TrTJJ","header__logo--index":"Logo_header__logo--index__Qpq-i","logo--right":"Logo_logo--right__OP7mh"};